// extracted by mini-css-extract-plugin
export default {"articleWrapper":"articlePage_articleWrapper__+y6nP","articleInfo":"articlePage_articleInfo__nL5hS"};